import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import { toast } from 'react-hot-toast';

export const useReports = (page = 1, perPage = 10) => {
    const queryClient = useQueryClient();

    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['companyReports', page, perPage],
        queryFn: () =>
            api.get('/company/reports', { params: { page, per_page: perPage } }).then(res => res.data),
        keepPreviousData: true,
    });

    const approveMutation = useMutation({
        mutationFn: ({ id, is_approved }) =>
            api.put(`/company/reports/${id}/approval`, { is_approved }),
        onSuccess: () => {
            toast.success('Report status updated');
            queryClient.invalidateQueries(['companyReports']);
        },
        onError: (err) => {
            toast.error(err.response?.data?.message || 'Failed to update report status');
        }
    });

    return {
        reports: data?.data || [],
        pagination: data?.pagination || {},
        isLoading,
        error,
        refetch,
        approveReport: approveMutation.mutate,
        isApproving: approveMutation.isLoading,
    };
};